import React from "react";
import ModalPopup from "@components/Common/ModalPopup";
import { RiDraftFill } from "react-icons/ri";
import { FaThumbsUp } from "react-icons/fa";
import { MdOutlineSmsFailed } from "react-icons/md";

/**
 * SubmitModal Component
 * Success modal displayed after form submission
 */
export const SubmitModal = ({ isOpen, setIsOpen }) => {
  return (
    <ModalPopup
      className="ModalPopup_Submitted"
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      title="Submitted Successfully"
      data="Your market visit report form has been submitted successfully."
      backdrop={true}
      fade={false}
      icon={
        <div className="submittedIcons draftIcons">
          <FaThumbsUp className="submittedSmall" />
          <FaThumbsUp className="submittedLarge" />
          <FaThumbsUp className="submittedSmall" />
        </div>
      }
    />
  );
};

/**
 * DraftModal Component
 * Success modal displayed after saving as draft
 */
export const DraftModal = ({ isOpen, setIsOpen }) => {
  return (
    <ModalPopup
      className="ModalPopup_Submitted"
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      title="Saved as Draft"
      data="Your market visit report form has been saved successfully."
      backdrop={true}
      fade={false}
      icon={
        <div className="submittedIcons draftIcons">
          <RiDraftFill className="draftSmall" />
          <RiDraftFill className="draftLarge" />
          <RiDraftFill className="draftSmall" />
        </div>
      }
    />
  );
};

/**
 * ErrorModal Component
 * Error modal displayed when save fails
 */
export const ErrorModal = ({ isOpen, setIsOpen, message }) => {
  return (
    <ModalPopup
      className="ModalPopup_Submitted"
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      title="Failed"
      data={message || "Something went wrong. Please try again."}
      backdrop={true}
      fade={false}
      icon={
        <div className="submittedIcons errorIcons">
          <MdOutlineSmsFailed className="errorSmall" />
          <MdOutlineSmsFailed className="errorLarge" />
          <MdOutlineSmsFailed className="errorSmall" />
        </div>
      }
    />
  );
};
